export const DownloadSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 13h12M8 2v8M8 10l-3-3M8 10l3-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RefreshSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3332 8.00004C13.3332 10.9456 10.9454 13.3334 7.99984 13.3334C5.05432 13.3334 2.6665 10.9456 2.6665 8.00004C2.6665 5.05452 5.05432 2.66671 7.99984 2.66671C9.65125 2.66671 11.1273 3.41705 12.1058 4.59483M12.1058 4.59483V2.66671M12.1058 4.59483H10.1777"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIconSvg = ({ color = 'currentColor' }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 7L5.5 10L11.5 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const TriangleSvg = ({ color = 'currentColor' }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M16.2993 13.5007L10.2993 3.00066C10.1685 2.76981 9.97873 2.5778 9.74947 2.44421C9.52021 2.31062 9.25962 2.24023 8.99428 2.24023C8.72894 2.24023 8.46834 2.31062 8.23909 2.44421C8.00983 2.5778 7.82011 2.76981 7.68928 3.00066L1.68928 13.5007C1.55704 13.7297 1.4877 13.9896 1.48828 14.254C1.48887 14.5185 1.55936 14.7781 1.69261 15.0065C1.82586 15.235 2.01714 15.4241 2.24705 15.5548C2.47696 15.6855 2.73733 15.753 3.00178 15.7507H15.0018C15.265 15.7504 15.5234 15.6809 15.7512 15.5491C15.9791 15.4174 16.1682 15.228 16.2997 15C16.4311 14.772 16.5003 14.5134 16.5002 14.2503C16.5002 13.9871 16.4309 13.7286 16.2993 13.5007Z"
      stroke={color}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 6.75V9.75" stroke={color} strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 12.75H9.00667" stroke={color} strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PendingIconSvg = ({ color = 'currentColor' }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="5" stroke={color} strokeWidth="1.5" />
  </svg>
);

export const TimeoutIconSvg = ({ color = '#FFA940' }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="5.25" stroke={color} strokeWidth="1.2" />
    <path d="M7 3.85V7L9.1 8.4" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
